import React, { Component } from 'react'

import Idea from '../components/powerlayer'

import $ from 'jquery'

export default class IdeaPage extends Component {

  componentDidMount () {
    $('html, body').animate({scrollTop: $('.Idea').offset().top - 83}, 1000)
  }

  componentDidUpdate () {
    $('html, body').animate({scrollTop: $('.Idea').offset().top - 83}, 1000)
  }

  render () {
    return (
      <div className='Idea'>
        <Idea {...this.props} />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/ideapage.js
 **/